import { resolvePlantLoanPlan } from "../../../../../../infrastructure/utils/plantLoanPlans";
import { formatCurrency } from "../../../../../../infrastructure/utils/formatters";
import { resolveLoanGuaranteeChequeIntentLabel } from "../../customerRequest/loanGuaranteeChequeIntentConstants";

const POWER_PLANT_TYPE_BY_NAME = {
  GridConnected: "1",
  OffGrid: "2",
  Hybrid: "3",
  HybridWithoutBattery: "4",
};

const LOAN_TYPE_LABELS = {
  1: "وام مهرسان (متصل به شبکه)",
  3: "وام مهرسان (هیبریدی)",
  4: "وام مهرسان (هیبریدی بدون باطری)",
};

function normalizePlantType(raw) {
  if (raw == null || raw === "") return "";
  const str = String(raw).trim();
  if (/^\d+$/.test(str)) return str;
  return POWER_PLANT_TYPE_BY_NAME[str] || "";
}

/** Display-only loan block for operator review workspace. */
export function buildOperatorLoanSummary(values) {
  const plantType = normalizePlantType(
    values?.powerPlantType ?? values?.PowerPlantType
  );
  const plan = resolvePlantLoanPlan(plantType);

  const needsLoan = Boolean(
    values?.needsLoan ?? values?.NeedsLoan
  );
  const chequeIntentLabel =
    values?.loanGuaranteeChequeIntentTitle ||
    values?.LoanGuaranteeChequeIntentTitle ||
    resolveLoanGuaranteeChequeIntentLabel(
      values?.loanGuaranteeChequeIntent ?? values?.LoanGuaranteeChequeIntent
    );

  if (!plantType) {
    return {
      show: true,
      active: false,
      message: "نوع نیروگاه ثبت نشده — اطلاعات وام پس از ثبت نوع نمایش داده می‌شود.",
    };
  }

  if (plantType === "2" || !plan.available) {
    return {
      show: true,
      active: false,
      message: "وام فعال نیست",
    };
  }

  return {
    show: true,
    active: true,
    loanTypeLabel: LOAN_TYPE_LABELS[plantType] || plan.planTitle,
    chequeIntentLabel: needsLoan ? chequeIntentLabel : "",
    ceilingLabel: formatCurrency(plan.maxLoanAmount),
    monthsLabel: `${plan.months.toLocaleString("fa-IR")} ماه`,
    installmentLabel: formatCurrency(plan.monthlyInstallment),
  };
}
